import Mutations from '../../odata/mutations';

export default { ...new Mutations('documentLink'), ...new Mutations('documentLinks') };
